import { categories } from "@/mocks/categories";

export default function HeroSection() {
  const handleCategorySelect = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20diverse%20fashion%20items%20including%20sneakers%20denim%20and%20accessories%20on%20textured%20linen%20fabric%2C%20bright%20natural%20sunlight%20from%20large%20window%2C%20light%20sand%20and%20ivory%20color%20palette%2C%20editorial%20ecommerce%20photography%2C%20organized%20chaos%20aesthetic%2C%20high%20resolution%20catalog%20style%2C%20airy%20and%20fresh%20composition&width=1800&height=1200&seq=hero-v2-main-bg&orientation=landscape"
          alt="ACBuy Spreadsheet — Smart Shopping Platform"
          title="ACBuy Spreadsheet — Smart Shopping Platform"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 md:pt-28">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/90 backdrop-blur-sm border border-background-200/50 rounded-full mb-8">
            <span className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></span>
            <span className="text-xs md:text-sm text-foreground-700 font-medium tracking-wide">
              Updated Daily · 2026 Spreadsheet Database
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 tracking-tight leading-tight mb-4 md:mb-5">
            ACBuy Spreadsheet
          </h1>
          <p className="font-heading text-2xl md:text-4xl lg:text-5xl text-background-50/85 font-light italic mb-6 md:mb-8">
            Smart Shopping System for 2026
          </p>

          <p className="text-sm md:text-base text-background-50/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            Compare, track, and discover the best products using the most updated{" "}
            <strong>acbuyspreadsheet database</strong>, designed for faster, safer, and
            more transparent online shopping decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
            >
              <i className="ri-file-list-3-line mr-2"></i>
              ACBuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/95 backdrop-blur-sm text-foreground-900 rounded-lg text-base font-semibold hover:bg-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-cart-2-line mr-2"></i>
              Buy It Now
            </a>
          </div>

          <div className="max-w-sm mx-auto">
            <label className="block text-xs text-background-50/80 mb-2 text-left font-semibold tracking-wide uppercase">
              Browse by Category
            </label>
            <div className="relative">
              <select
                onChange={(e) => {
                  if (e.target.value) handleCategorySelect(e.target.value);
                }}
                defaultValue=""
                className="w-full px-4 py-3 pr-10 bg-background-50/95 backdrop-blur-sm border border-background-200/50 rounded-lg text-sm text-foreground-800 appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400/50 transition-all"
              >
                <option value="" disabled>
                  Select a category...
                </option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.url}>
                    {cat.name} ({cat.count})
                  </option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 pointer-events-none"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-xs text-background-50/70 tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-background-50/70 animate-bounce"></i>
      </div>
    </section>
  );
}